import { CompanyLicensingTabController } from '../controller/CompanyLicensingTabController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { CompanyActionContext } from '../../types/CompanyActionContext';
import { getContext } from '../../../../componentHelpers/getters';
import { CompanyData } from '../../../types/company-data';
import { BaseWebComponentTranslator } from '../../../../framework/BaseWebComponentTranslator';
import { GzDialogWebComponent } from '../../../../ui/gzDialog';

export class CompanyLicensingTabWebComponent extends BaseWebComponentElement {
  public controller!: CompanyLicensingTabController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: CompanyLicensingTabController,
    });
  }

  public get context(): CompanyActionContext {
    return getContext.call(this);
  }

  public get initialCompanyData(): CompanyData {
    const dataInitialCompany = this.getAttribute('data-initial-company') ?? '';

    try {
      return JSON.parse(dataInitialCompany);
    } catch (e) {
      throw new Error(BaseWebComponentTranslator.getInstance().getCommonStrings().genericError);
    }
  }

  public set initialCompanyData(company: CompanyData) {
    this.setAttribute('data-initial-company', JSON.stringify(company));
  }

  public get hasUnsavedChanges(): boolean {
    // there are no forms in "Licensing" tab which can have unsaved changes
    return false;
  }

  public set sideMenuParentDialog(parent: GzDialogWebComponent) {
    this.controller.view.sideMenuParentDialog = parent;
  }

  public discardFormChanges(): void {
    return this.controller.view.discardFormChanges();
  }

  public updateGeneralAddProductViewData(canBeManagedByAbove: boolean): void {
    return this.controller.view.updateGeneralAddProductViewData(canBeManagedByAbove);
  }
}
